import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgScratchcard = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.464 2.25a.75.75 0 1 0 0 1.5h9.072a.75.75 0 0 0 0-1.5zm-2.732 3.5a.75.75 0 0 1 .75-.75h13.036a.75.75 0 1 1 0 1.5H5.482a.75.75 0 0 1-.75-.75M4.75 8.5A2.75 2.75 0 0 0 2 11.25v7A2.75 2.75 0 0 0 4.75 21h14.5A2.75 2.75 0 0 0 22 18.25v-7a2.75 2.75 0 0 0-2.75-2.75zM3.5 11.25c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25zm10.821 0a1.75 1.75 0 0 0-1.75 1.75v3.5c0 .966.784 1.75 1.75 1.75h3.286a1.75 1.75 0 0 0 1.75-1.75V13a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h3.286a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25h-3.286a.25.25 0 0 1-.25-.25zm-9.34-1.062a.75.75 0 0 1 .75-.75h4.447a.75.75 0 1 1 0 1.5H5.482a.75.75 0 0 1-.75-.75m.75 2a.75.75 0 0 0 0 1.5h4.447a.75.75 0 1 0 0-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgScratchcard;
